/*
 * This component is a card component for continuity across the app.
 *
 * @author Cargomatic Engineering
 * @usage <CargomaticCollapsibleCard />
 *
 */
import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../utils/ui/classes';
import { Card, CardContent, CardFooter, CardHeader, CardTitle, } from '@cargomatic/ui';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { ChevronDown, ChevronRight } from 'lucide-react';
const CargomaticCollapsibleCard = forwardRef(({ id, children, grayFooter, header, headerParams, footer, className, dataTestId, }, ref) => {
    var _a;
    const key = id ? `${id}-card-state` : undefined;
    const [cardState, setCardState] = useLocalStorage(key);
    const [open, setOpen] = useState((_a = cardState === null || cardState === void 0 ? void 0 : cardState.open) !== null && _a !== void 0 ? _a : true);
    const footerClassName = getClassName({
        'bg-gray-50': grayFooter,
    });
    const handleOpenClick = () => {
        setOpen(!open);
        setCardState({ open: !open });
    };
    return (React.createElement(Card, { "data-testid": dataTestId, ref: ref, className: getClassName(className) },
        header && (React.createElement(CardHeader, null,
            React.createElement("div", { className: "flex space-x-2" },
                React.createElement("button", { "data-testid": "button-cd4fe1b2", onClick: handleOpenClick }, open ? (React.createElement(ChevronDown, { className: "w-4 h-4" })) : (React.createElement(ChevronRight, { className: "w-4 h-4" }))),
                React.createElement(CardTitle, { className: "flex-1" },
                    React.createElement("div", { "data-testid": "div-5d044744" }, header(headerParams)))))),
        open && children && (React.createElement(CardContent, null,
            React.createElement("div", { "data-testid": "div-1fc043d2" }, children))),
        footer && (React.createElement(CardFooter, null,
            React.createElement("div", { "data-testid": "div-0e71b504", className: footerClassName }, footer())))));
});
CargomaticCollapsibleCard.propTypes = {
    children: PropTypes.any,
    header: PropTypes.func,
    headerParams: PropTypes.object,
    footer: PropTypes.func,
    grayBody: PropTypes.bool,
    grayFooter: PropTypes.bool,
    removeVerticalPadding: PropTypes.bool,
    removeHorizontalPadding: PropTypes.bool,
    removeBorders: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
CargomaticCollapsibleCard.defaultProps = {
    grayBody: false,
    grayFooter: false,
    removeHorizontalPadding: false,
    removeVerticalPadding: false,
    removeBorders: false,
};
export default CargomaticCollapsibleCard;
